import { crudService } from '../_services';
import { history } from '../_helpers';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';
import { stringUtils } from '../_utils';

export const tiposUsuariosAction = {
    getTipoUsuario,
    getTipoUsuarioSelect,
    getTipoUsuarioById,
    onChangeProps,
    editTipoUsuarioInfo,
    createTipoUsuario,
    deleteTipoUsuarioById,
    clear
};

let filterModel = {
    Page: 1,
    Limit: 10,
    Term: ''
};

function getTipoUsuario(filterModel) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'tiposUsuarios' + stringUtils.serialize(filterModel);
        crudService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeTiposUsuariosList(response.data.items, response.data.totalPages));
                }
                alerts.clean();
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function getTipoUsuarioSelect() {
    return dispatch => {
        let apiEndpoint = 'tiposUsuarios/select';
        crudService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    response.data.unshift({ value: '', text: ' SELECIONE ...' });
                    dispatch(changeTiposUsuariosList(response.data, null));
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function createTipoUsuario(payload) {
    return dispatch => {
        let apiEndpoint = 'tiposUsuarios/';
        crudService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    history.push(ret.path);
                    alerts.success(ret.message);
                } else {
                    alerts.warning(response.request.responseText);
                }
            });
    };
}
function getTipoUsuarioById(id) {
    return dispatch => {
        let apiEndpoint = 'tiposUsuarios/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(editTiposUsuariosDetails(response.data));
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}
function editTipoUsuarioInfo(id, payload) {
    return dispatch => {
        let apiEndpoint = 'tiposUsuarios/' + id;
        crudService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    history.push(ret.path);
                    alerts.success(ret.message);
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function deleteTipoUsuarioById(id) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {

                    let apiEndpoint = 'tiposUsuarios/' + id;
                    crudService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteTiposUsuariosDetails());
                                dispatch(getTipoUsuario(filterModel));
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err);
                            alerts.error(err);
                        });

                }
            });

    };
}
export function changeTiposUsuariosList(tipoUsuario, totalPages) {
    return {
        type: "FETECHED_ALL_TIPO_USUARIO",
        tipoUsuario: tipoUsuario,
        totalPages: totalPages
    };
}
export function clear() {
    return {
        type: "TIPO_USUARIO_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE_TIPO_USUARIO",
        props: props,
        value: value
    };
}
export function editTiposUsuariosDetails(tipoUsuario) {
    return {
        type: "TIPO_USUARIO_DETAIL",
        id: tipoUsuario.id,
        nome: tipoUsuario.nome,
        todasEntidades: tipoUsuario.todasEntidades,
        excluido: tipoUsuario.excluido
    }
}
export function updatedUserInfo() {
    return {
        type: "TIPO_USUARIO_UPDATED"
    };
}
export function createUserInfo() {
    return {
        type: "TIPO_USUARIO_CREATED_SUCCESSFULLY"
    };
}
export function deleteTiposUsuariosDetails() {
    return {
        type: "DELETED_TIPO_USUARIO_DETAILS"
    };
}